import React, { useState } from 'react';
import { Button } from 'antd';
import { Icon } from '@docs/kd-d2c-components';
import { eed_mario_icon_arrow_continue_line } from '@src/assets/icons';
import deepResearchClarIcon from '@/assets/images/deep_research.png';
import { Text } from './text';
import './deep-research-clar.less';
import { Message } from '@docs/kd-d2c-components';

export interface IDeepResearchClarItem {
  id: string;
  type: 'text';
  label: string;
  value: string;
}

export interface IDeepResearchClarFormAction {
  text: string;
  type: 'button';
  variant: 'primary';
  disabled: boolean;
}

export interface IDeepResearchClarConfig {
  title: string;
  formItems: IDeepResearchClarItem[];
  action: IDeepResearchClarFormAction;
}

interface DeepResearchClarProps {
  config: IDeepResearchClarConfig;
  onSubmit: (
    formItems: IDeepResearchClarItem[],
    action: IDeepResearchClarFormAction,
  ) => Promise<void>;
}

export const DeepResearchClar: React.FC<DeepResearchClarProps> = ({
  config,
  onSubmit,
}) => {
  const [formData, setFormData] = useState<IDeepResearchClarItem[]>(
    config.formItems,
  );
  const [action, setAction] = useState<IDeepResearchClarFormAction>(
    config.action,
  );
  const [loading, setLoading] = useState(false);
  const updateFormData = (id: string, value: string) => {
    setFormData((prev) =>
      prev.map((item) => (item.id === id ? { ...item, value } : item)),
    );
  };
  const disabled = loading || action.disabled;

  return (
    <div className="mario-deep-research-clar">
      <div className="mdr-header">
        <img src={deepResearchClarIcon} />
        <div className="mdr-header-right">
          <div className="mdr-header-right-title">{config.title}</div>
          <div className="mdr-header-right-description">
            点击内容，开始自定义编辑
          </div>
        </div>
      </div>
      <div className="mdr-form">
        {formData.map((item, idx) => (
          <div className="mdr-form-item" key={item.id}>
            <div className="mdr-form-item-label">{item.label}</div>
            <div className="mdr-form-item-value">
              <Text
                disabled={disabled}
                value={item.value}
                onChange={(value) => {
                  updateFormData(item.id, value);
                }}
                maxLength={idx === 1 ? 100 : 50}
              />
            </div>
          </div>
        ))}
        <div className="mdr-form-actions">
          <Button
            type="primary"
            className="mdr-form-actions-button"
            disabled={disabled}
            icon={<Icon size={16} icon={eed_mario_icon_arrow_continue_line} />}
            iconPosition="end"
            onClick={() => {
              if (formData[0].value.trim() === '') {
                Message.error({ message: '请输入研究对象' });
                return;
              }
              setLoading(true);
              const newAction = { ...action, disabled: true, text: '已继续' };
              onSubmit(formData, newAction)
                .then(() => {
                  setLoading(false);
                  setAction(newAction);
                })
                .catch(() => {
                  setLoading(false);
                });
            }}
          >
            {action.text}
          </Button>
        </div>
      </div>
    </div>
  );
};
